import React, { useState } from "react";
import ReactSelect from "react-select";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000811",
    whiteSpace: "nowrap",
  }),
};

const FieldSkeleton = () => (
  <div className="user-field-skeleton">
    <div className="skeleton-label" />
    <div className="skeleton-input" />
  </div>
);

const UserInformationSkeleton = () => (
  <div className="card mb-2">
    <div className="card-header">
      <h2>Personal Information</h2>
    </div>

    <div className="card-body bg-white">
      <div className="user-information-grid">
        {Array.from({ length: 11 }, (_, index) => (
          <FieldSkeleton key={index} />
        ))}
      </div>
    </div>
  </div>
);

const UserInformation = (props) => {
  const {
    loading,
    userTypedrp,
    handleUserTypeChange,
    userType,
    formErrors,
    formValues,
    handleFormChange,
    showPassword,
    showConfirmPassword,
    userRoleDrp,
    handleUserRoleChange,
    UserRoleName,
    distributorDrp,
    companyDrp,
    handleCompanyChange,
    companyName,
    departmentDrp,
    handleDepartmentChange,
    departmentName,
    designationDrp,
    handleDesignationChange,
    designationName,
    userReportDrp,
    handleUserReportingChange,
    UserReportingName,
    handleToggleChange,
    clearFormValues,
    setFormErrors,
    setFormValues,
  } = props;

  const [isBlock, setIsBlock] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  function handleToggleBlockChange() {
    const newValue = !formValues.isActive;

    setIsBlock(newValue);

    setFormValues({
      ...formValues,
      isActive: newValue,
    });
  }

  if (loading) {
    return <UserInformationSkeleton />;
  }

  return (
    <>
      <div className="card mb-2">
        <div className="card-header">
          <h2>Personal Information</h2>
        </div>

        <div className="card-body bg-white">
          <div className="user-information-grid">

            {/* User Type */}
            <div className="user-information-field">
              <label>
                User Type <span className="mandatory">*</span>
              </label>

              <ReactSelect
                className="basic-multi-select"
                hideSelectedOptions={false}
                allowSelectAll={true}
                options={userTypedrp}
                onChange={handleUserTypeChange}
                value={userType}
                name="userType"
                id="userType"
                placeholder={PlaceHolder?.SELECT_USER_TYPE}
                styles={style}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral80: "#000000",
                  },
                })}
              />

              {formErrors?.userType && (
                <p className="form-error">{formErrors.userType}</p>
              )}
            </div>

            {/* First Name */}
            <div className="user-information-field">
              <label>
                First Name <span className="mandatory">*</span>
              </label>

              <input
                className="form-control"
                type="text"
                placeholder={PlaceHolder?.FIRST_NAME}
                name="firstName"
                id="firstName"
                value={formValues.firstName}
                onChange={handleFormChange}
              />

              {formErrors?.firstName && (
                <p className="form-error">{formErrors.firstName}</p>
              )}
            </div>

            {/* Last Name */}
            <div className="user-information-field">
              <label>
                Last Name <span className="mandatory">*</span>
              </label>

              <input
                className="form-control"
                type="text"
                placeholder={PlaceHolder?.LAST_NAME}
                name="lastName"
                id="lastName"
                value={formValues.lastName}
                onChange={handleFormChange}
              />

              {formErrors?.lastName && (
                <p className="form-error">{formErrors.lastName}</p>
              )}
            </div>

            {/* Email */}
            <div className="user-information-field">
              <label>
                User Name (Email Address){" "}
                <span className="mandatory">*</span>
              </label>

              <input
                className="form-control"
                type="text"
                placeholder={PlaceHolder?.EMAIL}
                name="userName"
                id="userName"
                value={formValues.userName}
                onChange={handleFormChange}
                autoComplete="off"
                disabled={!!formValues.id}
              />

              {!formValues?.id && formErrors?.userName && (
                <p className="form-error">{formErrors.userName}</p>
              )}
            </div>
            {!formValues?.id && (
              <div className="user-information-field">
                <label>
                  Password <span className="mandatory">*</span>
                </label>

                <div className="input-group">
                  <input
                    className="form-control"
                    type={showPwd ? "text" : "password"}
                    placeholder={PlaceHolder?.PASSWORD}
                    name="password"
                    id="password"
                    value={formValues.password}
                    onChange={handleFormChange}
                    autoComplete="new-password"
                  />

                  <div className="input-group-append">
                    <button
                      type="button"
                      onClick={() => setShowPwd(!showPwd)}
                      tabIndex="-1"
                      className="user-password-toggle"
                      aria-label={
                        showPwd ? "Hide password" : "Show password"
                      }
                    >
                      <i
                        className={`fas ${
                          showPwd ? "fa-eye" : "fa-eye-slash"
                        }`}
                      />
                    </button>
                  </div>
                </div>

                {formErrors?.password && (
                  <p className="form-error">{formErrors.password}</p>
                )}
              </div>
            )}

            {/* User Role */}
            <div className="user-information-field">
              <label>
                User Role <span className="mandatory">*</span>
              </label>

              <ReactSelect
                className="basic-multi-select"
                hideSelectedOptions={false}
                allowSelectAll={true}
                options={userRoleDrp}
                onChange={handleUserRoleChange}
                value={UserRoleName}
                name="roleId"
                id="roleId"
                placeholder={PlaceHolder?.SELECT_USER_ROLE}
                styles={style}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral80: "#000000",
                  },
                })}
              />

              {formErrors?.roleId && (
                <p className="form-error">{formErrors.roleId}</p>
              )}
            </div>

            {/* Phone Number */}
            <div className="user-information-field">
              <label>
                Phone Number <span className="mandatory">*</span>
              </label>

              <PhoneNumberComponent
                errors={formErrors}
                setValues={setFormValues}
                setErrors={setFormErrors}
                filedName="phone"
                values={formValues}
              />

              {formErrors?.phone && (
                <p className="form-error">{formErrors.phone}</p>
              )}
            </div>

            {/* Company / Distributor */}
            <div className="user-information-field">
              <label>
                {userType
                  ? userType.value === "2"
                    ? "Distributor"
                    : "Company"
                  : "Company"}{" "}
                Name <span className="mandatory">*</span>
              </label>

              <ReactSelect
                className="basic-multi-select"
                hideSelectedOptions={false}
                allowSelectAll={true}
                options={
                  userType?.value === "2"
                    ? distributorDrp
                    : companyDrp
                }
                onChange={handleCompanyChange}
                value={companyName}
                name="userCompanyId"
                id="userCompanyId"
                styles={style}
                placeholder={`Choose ${
                  userType?.value === "2" ? "distributor" : "company"
                } name`}
                isDisabled={userType === null}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral80: "#000000",
                  },
                })}
              />

              {formErrors?.userCompanyId && (
                <p className="form-error">
                  {formErrors.userCompanyId}
                </p>
              )}
            </div>

            {/* Department */}
            <div className="user-information-field">
              <label>
                Department <span className="mandatory">*</span>
              </label>

              <ReactSelect
                className="basic-multi-select"
                hideSelectedOptions={false}
                allowSelectAll={true}
                options={departmentDrp}
                onChange={handleDepartmentChange}
                value={departmentName}
                name="department"
                id="department"
                placeholder={PlaceHolder?.SELECT_DEPARTMENT}
                styles={style}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral80: "#000000",
                  },
                })}
              />

              {formErrors?.department && (
                <p className="form-error">{formErrors.department}</p>
              )}
            </div>

            {/* Designation */}
            <div className="user-information-field">
              <label>
                Designation <span className="mandatory">*</span>
              </label>

              <ReactSelect
                className="basic-multi-select"
                hideSelectedOptions={false}
                allowSelectAll={true}
                options={designationDrp}
                onChange={handleDesignationChange}
                value={designationName}
                name="designation"
                id="designation"
                placeholder={PlaceHolder?.SELECT_DESIGNATION}
                styles={style}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral80: "#000000",
                  },
                })}
              />

              {formErrors?.designation && (
                <p className="form-error">{formErrors.designation}</p>
              )}
            </div>

            {/* Reporting To */}
            <div className="user-information-field">
              <label>
                Reporting To <span className="mandatory">*</span>
              </label>

              <ReactSelect
                className="basic-multi-select"
                hideSelectedOptions={false}
                allowSelectAll={true}
                options={userReportDrp}
                onChange={handleUserReportingChange}
                value={UserReportingName}
                name="reportingTo"
                id="reportingTo"
                placeholder={PlaceHolder?.SELECT_REPORTING}
                styles={style}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral80: "#000000",
                  },
                })}
              />

              {formErrors?.reportingTo && (
                <p className="form-error">{formErrors.reportingTo}</p>
              )}
            </div>

            {/* Edit User only: Show / Hide User */}
            {formValues?.id && (
              <div className="user-information-field">
                <label>Show/Hide User</label>

                <div className="custom-control custom-switch mt-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="isActive"
                    name="isActive"
                    checked={!!formValues.isActive}
                    onChange={handleToggleBlockChange}
                  />

                  <label
                    className="custom-control-label"
                    htmlFor="isActive"
                  >
                    {formValues.isActive ? "Hide User" : "Show User"}
                  </label>
                </div>
              </div>
            )}

            {/* Edit User only: Enable / Disable Login */}
            {formValues?.id && (
              <div className="user-information-field">
                <label>Enable/Disable User</label>

                <div className="custom-control custom-switch mt-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="loginDisabled"
                    name="loginDisabled"
                    checked={!!formValues.loginDisabled}
                    onChange={handleToggleChange}
                  />

                  <label
                    className="custom-control-label"
                    htmlFor="loginDisabled"
                  >
                    Disable login
                  </label>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default UserInformation;